// extracted by mini-css-extract-plugin
export default {"spinner":"GreySpinner_spinner__3ZcWu","spin":"GreySpinner_spin__3ZqO2"};